import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './style.css';

class FormButton extends Component {
  static propTypes = {
    className: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.string.isRequired,
    primary: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func
  };
  static defaultProps = {
    className: '',
    type: 'button',
    primary: false,
    disabled: false,
    onClick: () => {}
  };
  shouldComponentUpdate(nextProps) {
    if (this.props.className !== nextProps.className ||
        this.props.label !== nextProps.label ||
        this.props.primary !== nextProps.primary ||
        this.props.disabled !== nextProps.disabled ||
        this.props.onClick !== nextProps.onClick) {
      return true;
    }
    return false;
  }
  render() {
    const { className, label, primary, type, disabled, onClick } = this.props;
    const classList = classNames('button', className, {
      'button-primary': primary
    });
    return (
      <button
        className={classList}
        type={type}
        disabled={disabled}
        onClick={onClick}>
        <span className="button-label">{label}</span>
      </button>
    );
  }
}

export default FormButton;